export const EIGHT_CHARACTERS_MIN_MATCH = 'EIGHT_CHARACTERS_MIN_MATCH';
export const UPPER_LOWER_CHARACTER_MATCH = 'UPPER_LOWER_CHARACTER_MATCH';
export const DIGIT_SYMBOL_MATCH = 'DIGIT_SYMBOL_MATCH';
export const PASSWORD_MATCH_RETYPED = 'PASSWORD_MATCH_RETYPED';